export const GetProfileActionTypes = {
  GET_PROFILE_LOADING: "GET_PROFILE_LOADING",
  GET_PROFILE_ERROR: "GET_PROFILE_ERROR",
  GET_PROFILE_SUCCESS: "GET_PROFILE_SUCCESS",
};
